import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Breadcrumbs from 'components/Breadcrumbs';
import PageBlock from 'components/PageBlock';
import { fetchMerchandise } from 'store/destination/destinationActions';
import { getDestination } from 'store/destination/destinationSelectors';
import Templates from './Templates';
import DestinationHelmet from './DestinationHelmet';
import Loader from 'components/Loader';
import { DESTINATION_STATUS } from 'lib/enums/destination';
import LoaderComponent from './LoaderComponent';
import FourOhFourPage from 'pages/FourOhFour';

const DestinationLayout = () => {
  const dispatch = useDispatch();
  const destination = useSelector(getDestination) || {};
  const { breadcrumbs, regionId, status, template } = destination;

  const hasFailed = status === DESTINATION_STATUS.FAILED;
  const isLoading = status === DESTINATION_STATUS.PENDING;
  const isCountry = template === 'country';

  useEffect(() => {
    if (regionId) {
      dispatch(fetchMerchandise({ limit: 4, regionId, subRegionLimit: 6 }));
    }
  }, [dispatch, regionId]);

  return (
    <Fragment>
      {hasFailed ? (
        <FourOhFourPage />
      ) : (
        <Fragment>
          <DestinationHelmet destination={destination} />

          {breadcrumbs && !isCountry && (
            <PageBlock bg="white" px={[4, 6, 10]} display={['none', 'block']}>
              <Breadcrumbs context="Destination" crumbs={breadcrumbs} />
            </PageBlock>
          )}

          <Loader isLoading={isLoading} loaderComponent={LoaderComponent}>
            <Templates />
          </Loader>
        </Fragment>
      )}
    </Fragment>
  );
};

export default DestinationLayout;
